import { useEffect, useRef, useState } from "react"
import { usePortalLanguage } from "./virtualFarmerI18n"

export const normalizeDeviceClaimCode = (value) => {
     const digits = String(value ?? "").replace(/[\s-]/g, "")
     return /^[0-9]{8}$/.test(digits) ? `${digits.slice(0, 4)}-${digits.slice(4)}` : null
}

export default function DeviceClaimForm({ onClaim, onClaimChaac }) {
     const { t } = usePortalLanguage()
     const [code, setCode] = useState("")
     const [name, setName] = useState("")
     const [busy, setBusy] = useState(false)
     const [claimed, setClaimed] = useState(null)
     const [error, setError] = useState("")
     const [kind, setKind] = useState("aeroponic")
     const isChaac = kind === "chaac"
     const defaultName = isChaac ? "Chaac" : "FEEDER Aeroponic"
     const mounted = useRef(false)
     const pending = useRef(false)
     useEffect(() => {
          mounted.current = true
          return () => { mounted.current = false }
     }, [])
     const submit = async (event) => {
          event.preventDefault()
          if (pending.current) return
          const claimCode = normalizeDeviceClaimCode(code)
          setClaimed(null)
          if (!claimCode) { setError("service.claimFormat"); return }
          pending.current = true
          setBusy(true)
          setError("")
          try {
               const result = await (isChaac ? onClaimChaac : onClaim)({ claimCode, displayName: name.trim() || defaultName })
               if (!mounted.current) return
               if (result) { setClaimed(result); setCode(""); setName("") }
               else setError("service.claimUnconfirmed")
          } catch {
               // A lost response does not prove the write failed. Never retry
               // automatically or show raw server errors/device credentials.
               if (mounted.current) setError("service.claimUnconfirmed")
          } finally {
               pending.current = false
               if (mounted.current) setBusy(false)
          }
     }
     return <form className="vf-card vf-device-claim-card" data-testid="device-claim-form" onSubmit={submit} aria-busy={busy}>
          <div><p className="vf-eyebrow">{t("service.claimEyebrow")}</p><h3>{isChaac ? t("service.claimChaacTitle") : t("service.claimTitle")}</h3>
               {onClaimChaac && <label>{t("service.claimDeviceType")}<select value={kind} disabled={busy} onChange={(event) => {
                    setKind(event.target.value); setCode(""); setName(""); setError(""); setClaimed(null)
               }}><option value="aeroponic">FEEDER Aeroponic</option><option value="chaac">Chaac</option></select></label>}
               <p>{t("service.claimText")}</p>
               <ol className="vf-connect-steps"><li>{t(isChaac ? "service.claimChaacStep1" : "service.claimStep1")}</li><li>{t(isChaac ? "service.claimChaacStep2" : "service.claimStep2")}</li></ol>
          </div>
          <div className="vf-device-claim-fields">
               <div><label>{t(isChaac ? "service.claimChaacCode" : "service.claimCode")}<input inputMode="numeric" autoComplete="one-time-code" autoCapitalize="none" spellCheck={false} maxLength={32} placeholder="1234-5678" value={code}
                    disabled={busy} aria-describedby="device-claim-code-help" aria-invalid={error === "service.claimFormat"}
                    onChange={(event) => { setCode(event.target.value); setError(""); setClaimed(null) }} required /></label>
               <small id="device-claim-code-help">{t("service.claimCodeHelp")}</small></div>
               <div><label>{t("service.deviceName")}<input maxLength={120} placeholder={defaultName} value={name} disabled={busy}
                    aria-describedby="device-claim-name-help" onChange={(event) => setName(event.target.value)} /></label>
               <small id="device-claim-name-help">{t(isChaac ? "service.claimChaacNameOptional" : "service.claimNameOptional")}</small></div>
               <button className="vf-primary-button" disabled={busy}>{busy ? t("service.claiming") : t("service.claimButton")}</button>
          </div>
          {error && <p role="alert">{t(error)}</p>}
          {claimed && <p className="vf-device-claim-success" role="status">{t("service.claimSuccess", { name: claimed.display_name || claimed.label || defaultName })}</p>}
          <p className="vf-safety-note">{t(isChaac ? "service.claimChaacScope" : "service.claimScope")}</p>
     </form>
}
